import React from 'react';

import { Tag } from 'antd';

interface IAwbProps {
    awbNumber: string | undefined;
}

const Awb = (props: IAwbProps) => {
    const { awbNumber } = props;

    if (!awbNumber) return undefined;
    
    return (
        <Tag color='cyan' style={{ marginLeft: 10, color: '#000000' }}>
            {awbNumber}
        </Tag>
    );
};

export default Awb;
